import React, { useEffect, useState } from "react";
import GalleryCard from "../components/GalleryCard";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerGalleries } from "../graphql/queries";

const client = generateClient();

const getGalleryDate = (gallery) => {
  try {
    // Check if ef1 exists and is a string before parsing
    const ef1 =
      typeof gallery.ef1 === "string" ? JSON.parse(gallery.ef1) : gallery.ef1;

    // Parse date, handling potential different formats
    return ef1?.date ? new Date(ef1.date) : new Date(0);
  } catch (error) {
    console.error(`Error parsing date for gallery item:`, gallery);
    return new Date(0);
  }
};

export function Gallery(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let pendingData = await client.graphql({
        query: listSlumSoccerGalleries,
      });

      // Sort gallery items by date, newest first
      const sortedGalleryItems = pendingData["data"][
        "listSlumSoccerGalleries"
      ].items.sort((a, b) => {
        const dateA = getGalleryDate(a);
        const dateB = getGalleryDate(b);
        return dateB - dateA; // Newest first
      });

      setData(sortedGalleryItems);
    } catch (error) {
      console.error("Error fetching or sorting gallery items:", error);
    }
  };

  return (
    <section className="py-16  bg-gradient-to-b from-gray-50 to-gray-100, animate__animated animate__bounceInUp">
      <div className="container mx-auto px-8">
        <div className="text-center mb-5">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5 ">
            Gallery
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.map((gallery) => {
            console.log(getGalleryDate(gallery));
            return (
            <GalleryCard
              key={gallery.galleryId}
              imgUrl={gallery.imgUrl}
              title={gallery.title}
            />)
          })}
        </div>
      </div>
    </section>
  );
}
